<template>
  <section class="section">
    <div class="container">
        <table class="table table-striped">
            <thead>
              <tr>
                <th>Nro</th>
                <th>Fecha</th>
                <th>Detalle</th>
                <th>Estado</th>
                <th>Monto</th>
                <th>Precio combo</th>
                <th>Detectado</th>
                <th>Calculado</th>
                <th>Calculado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pedido in pedidos">
                <td>{{pedido.numero}}</td>
                <td>{{pedido.fechaEntrega | formatearFecha}}</td>
                <td>{{pedido | platosSerialized}}</td>
                <td>{{pedido.estado}}</td>
                <td>{{pedido.montoTotal | formatearMoneda}}</td>
                <td>{{pedido.precio.precio | formatearMoneda}}</td>
                <td>{{ pedido.montoTotal / pedido.precio.precio}}</td>
                <td>{{pedido | multiplicadorCalculado}}</td>
                <td>{{pedido | montoPedido | formatearMoneda}}</td>
                <td>
                  <div class="input-group">
                    <input type="text" class="form-control input-sm" :ref="`input-${pedido._id}`">
                    <button class="btn btn-fill btn-sm" @click.prevent="cambiar(pedido._id, `input-${pedido._id}`)">Cambiar</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
    </div>
  </section>
</template>
<script>
  import moment from 'moment'
  export default {
    filters: {
      formatearFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      },
      formatearMoneda (value) {
        return `$ ${parseFloat(value).toFixed(2)}`
      },
      montoPedido (entrega) {
        let multiplicador = 0
        let primerCategoria = entrega.platos[0].plato.categoria._id
        let platosCategoria = entrega.platos.filter((plato) => {
          return plato.plato.categoria._id === primerCategoria
        })
        platosCategoria.forEach((plato) => {
          multiplicador += plato.cantidad
        })
        return multiplicador * entrega.precio.precio
      },
      multiplicadorCalculado (entrega) {
        let multiplicador = 0
        let primerCategoria = entrega.platos[0].plato.categoria._id
        let platosCategoria = entrega.platos.filter((plato) => {
          return plato.plato.categoria._id === primerCategoria
        })
        platosCategoria.forEach((plato) => {
          multiplicador += plato.cantidad
        })
        return multiplicador
      },
      platosSerialized (entrega) {
        let platos = entrega.platos.map((plato) => {
          return `${plato.cantidad}x ${plato.plato.nombre}`
        })
        return platos.join(' + ')
      },
      precioCombo (entrega) {
        const me = this
        console.log(entrega)
        let proveedor = me.proveedores.find((proveedor) => {
          return proveedor._id === entrega.proveedor
        })
        let precio = proveedor.precios.find((precio) => {
          return precio.combo._id === entrega.combo
        })
        return precio.precio
      }
    },
    data () {
      return {
        pedidos: [],
        proveedores: []
      }
    },
    methods: {
      cambiar (id, refInput) {
        const me = this
        let input = me.$refs[refInput]
        let valor = parseFloat(input[0].value)
        me.$http.post('/api/admin/cambiarmonto', {
          id: id,
          valor: valor
        }).then(({body}) => {
          let pedido = me.pedidos.find((ped) => {
            return ped._id === id
          })
          if (pedido) {
            pedido.montoTotal = valor
            me.pedidos.splice(me.pedidos.indexOf(pedido), 1, pedido)
          }
          me.$emit('mostrar-notificacion', 'Se ha cambiado el monto correctamente', 'success')
        }, (err) => {
          me.$emit('mostrar-notificacion', 'Se produjo un error al intentar cambiar el monto ' + err, 'error')
        })
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/admin/entregasmultiplicador').then(({body}) => {
        me.pedidos = body.entregas
        me.proveedores = body.proveedores
        me.pedidos.forEach((entrega) => {
          let proveedor = me.proveedores.find((proveedor) => {
            return proveedor._id === entrega.proveedor
          })
          let precio = proveedor.precios.find((precio) => {
            return precio.combo._id === entrega.combo
          })
          entrega.precio = precio
        })
      }, (err) => {
        console.error(err)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ReparadorPedidos.vue?522a823a